import React from 'react';

import { Icon } from '@atlas/ui';

const EventLiveStatusWidgets = ({ noIcons, swipe, widgets }) => {
  const renderWidgetIcon = (widgetType, iconName) => {
    if (widgets?.some(widget => widget.type === widgetType) && !noIcons) {
      return (
        <div className="event-sidebar-icon">
          <Icon height={18} name={iconName} width={18} />
        </div>
      );
    }
    return null;
  };

  return (
    <div className="event-live-status-icons">
      {renderWidgetIcon('VIDEO_STREAM', swipe ? 'live-stream' : 'match-video')}
      {renderWidgetIcon('SCORE_BOARD', swipe ? 'live-center' : 'match-center')}
      {renderWidgetIcon('STATISTIC', swipe ? 'statistics' : 'match-statistic')}
    </div>
  );
};

export default EventLiveStatusWidgets;
